import PostItem from './PostItem'

export default PostItem



// WEBPACK FOOTER //
// ./src/routes/Home/components/PostItem/index.js